import { AxiosResponse } from "axios";
import api from "../api";

interface APIGoal {
  minorAccountID: string;
  goalType: string;
  amountRequired: number;
  description: string;
  timeline: string;
}

export const insertGoals = async (
  goals: APIGoal[],
  auth: { userAccountID: string },
): Promise<AxiosResponse<unknown>> => {
  if (!goals || !auth || !auth.userAccountID) {
    throw new Error("insertGoals: Missing required parameters");
  }

  const formattedGoals = goals.map((goal) => {
    return {
      minorAccountID: goal.minorAccountID,
      goalType: goal.goalType,
      amountRequired: goal.amountRequired,
      description: goal.description,
      timeline: goal.timeline,
      sourceProcess: "WebApplication",
      modifiedUserAccountID: auth.userAccountID,
      changeReason: "Adding goal",
    };
  });

  return await api.post("/Goal/InsertGoal", formattedGoals);
};

export const updateGoals = async (
  goals: APIGoal[],
  auth: { userAccountID: string },
): Promise<AxiosResponse<unknown>> => {
  if (!goals || !auth || !auth.userAccountID) {
    throw new Error("updateGoals: Missing required parameters");
  }

  const formattedGoals = goals.map((goal) => {
    return {
      minorAccountID: goal.minorAccountID,
      goalType: goal.goalType,
      amountRequired: goal.amountRequired,
      description: goal.description,
      timeline: goal.timeline,
      sourceProcess: "WebApplication",
      modifiedUserAccountID: auth.userAccountID,
      changeReason: "Updating goal",
    };
  });

  return await api.put("/Goal/UpdateGoal", formattedGoals);
};

export const getAllGoals = async (userID: string) => {
  return await api.get(`/Goal/UserAccountID/${userID}`);
};
